import {
  CLEAR_BDO_SETTINGS,
  CREATE_BDO_SETTING,
  CREATE_BDO_SETTING_FAIL,
  CREATE_BDO_SETTING_SUCCESS,
  DELETE_BDO_SETTING,
  DELETE_BDO_SETTING_FAIL,
  DELETE_BDO_SETTING_SUCCESS,
  GET_BDO_SETTING,
  GET_BDO_SETTING_FAIL,
  GET_BDO_SETTING_SUCCESS,
  GET_BDO_SETTINGS,
  GET_BDO_SETTINGS_FAIL,
  GET_BDO_SETTINGS_SUCCESS,
  UPDATE_BDO_SETTING,
  UPDATE_BDO_SETTING_FAIL,
  UPDATE_BDO_SETTING_SUCCESS
} from './constants';

export const initialState = {
  loading: false,
  bdoSettings: null,
  bdoSetting: null,
  error: {}
};

function bdoSettingsReducer(state = initialState, action) {
  switch (action.type) {
    case GET_BDO_SETTINGS:
      return {
        ...state,
        loading: true,
        error: {}
      };
    case GET_BDO_SETTINGS_SUCCESS:
      return {
        ...state,
        loading: false,
        error: {},
        bdoSettings: action.payload
      };
    case GET_BDO_SETTINGS_FAIL:
      return {
        ...state,
        loading: false,
        error: action.error
      };
    case GET_BDO_SETTING:
      return {
        ...state,
        loading: true,
        error: {}
      };
    case GET_BDO_SETTING_SUCCESS:
      return {
        ...state,
        loading: false,
        error: {},
        bdoSetting: action.payload
      };
    case GET_BDO_SETTING_FAIL:
      return {
        ...state,
        loading: false,
        error: action.error
      };
    case CREATE_BDO_SETTING:
      return {
        ...state,
        loading: true,
        error: {}
      };
    case CREATE_BDO_SETTING_SUCCESS:
      return {
        ...state,
        loading: false,
        error: {},
        bdoSetting: action.payload.data
      };
    case CREATE_BDO_SETTING_FAIL:
      return {
        ...state,
        loading: false,
        error: action.error
      };
    case UPDATE_BDO_SETTING:
      return {
        ...state,
        loading: true,
        error: {}
      };
    case UPDATE_BDO_SETTING_SUCCESS:
      return {
        ...state,
        loading: false,
        error: {},
        bdoSetting: action.payload.data
      };
    case UPDATE_BDO_SETTING_FAIL:
      return {
        ...state,
        loading: false,
        error: action.error
      };
    case DELETE_BDO_SETTING:
      return {
        ...state,
        loading: true,
        error: {}
      };
    case DELETE_BDO_SETTING_SUCCESS:
      return {
        ...state,
        loading: false,
        error: {},
        bdoSettings: {
          ...state.bdoSettings,
          data: state.bdoSettings.data.filter(setting => setting.id !== action.payload)
        }
      };
    case DELETE_BDO_SETTING_FAIL:
      return {
        ...state,
        loading: false,
        error: action.error
      };
    case CLEAR_BDO_SETTINGS:
      return {
        ...state,
        bdoSetting: null,
        error: null
      };
    default:
      return state;
  }
}

export default bdoSettingsReducer;
